import { TextField } from "@material-ui/core";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Alert as AlertMaterialUI } from "@material-ui/lab";

export const Container = styled.section`
  display: flex;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 300px;
`;

export const Logo = styled.img`
  align-self: center;
  width: 180px;
  margin-bottom: 40px;
`;

export const CustomLink = styled(Link)`
  margin-top: 20px;
  align-self: center;
  color: #ffffff;
  text-decoration: none;
  font-weight: normal;
  font-size:13px;

  :hover {
    text-decoration: underline;
  }
`;

export const Input = styled(TextField)`
  margin-bottom: 10px !important;

  input {
    background: #ffffff;
  }
`;

export const Alert = styled(AlertMaterialUI)`
  margin-bottom: 20px;
`;

